/**
 * Protected Route Wrapper
 * Redirects to login if not authenticated or unauthorized
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useAppStore } from '../../stores'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'driver' | 'admin'
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAppStore()
  const location = useLocation()
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  // Check role if required
  if (requiredRole && user?.role !== requiredRole) {
    // Redirect to appropriate home based on role
    const redirectTo = user?.role === 'admin' ? '/admin' : '/delivery'
    return <Navigate to={redirectTo} replace />
  }
  
  return <>{children}</>
}
